export default "__VITE_ASSET__CQo0cHZ___"